import { Menu } from "antd";
import { useRouter } from "apps/hooks/useRouter";
import { ReactComponent as Account } from "assets/img/account.svg";
import { ReactComponent as Prompt } from "assets/img/bulb.svg";
import { ReactComponent as PrivateChatIcon } from "assets/img/chat.svg";
import { ReactComponent as HistoryManager } from "assets/img/clipboard.svg";
import { ReactComponent as FolderManager } from "assets/img/folderManager.svg";
import { ReactComponent as URL } from "assets/img/link.svg";
import { ReactComponent as Setting } from "assets/img/settings.svg";
import { ReactComponent as Rule } from "assets/img/shield.svg";
import { getUserInfo } from "features/auth/store/slice";
import { Children, FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ADMIN_ROLE, SUPER_ADMIN_ROLE, USER_ROLE } from "utils/constants";

import styles from "./styles.module.scss";

const SECURITY_COPILOT = "/security-copilot";
const API_COPILOT = "/api-copilot";
const AUDIT_COPILOT = "/audit-copilot";
const DOCUMENT_MANAGEMENT = "/document-management";
const CONFIG_PROMPT = "/config-prompt";
const CONFIG_RULES = "/config-rule";
const HISTORY_MANAGEMENT = "/history-management";
const USER_MANAGEMENT = "/user-management";
const CRAWLING_URL_MANAGEMENT = "/crawling-management";
const SECURITY_MANAGEMENT = "/security-management";

interface IItemMenu {
  key: string;
  label: JSX.Element | string;
  icon?: JSX.Element;
  children?: IItemMenu[];
  hidden?: boolean;
}

type ItemType = IItemMenu & {
  key: string;
  label: JSX.Element | string;
  icon?: JSX.Element;
  children?: IItemMenu[];
  hidden?: boolean;
};

const MenuComponent: FC = () => {
  const path = useRouter().pathname;
  const [key, setKey] = useState("/");

  const userInfo = useSelector(getUserInfo);
  const [menu, setMenu] = useState<any>([]);
  const securityLogActive = userInfo?.securityLog;
  useEffect(() => {
    let key = path;

    const temp: ItemType[] = menu.filter(
      (item: any) => key.includes(item?.key) && item?.key !== "/"
    );
    if (temp.length > 0) {
      if (temp[0].children) {
        key = temp[0].key;
      }
    }
    setKey(key);
  }, [path]);

  useEffect(() => {
    if (USER_ROLE.includes(userInfo?.role ?? "")) {
      setMenu([
        {
          label: (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI-powered Chat
            </span>
          ),
          children: [
            {
              key: SECURITY_COPILOT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={SECURITY_COPILOT}>Security Copilot</Link>
                </span>
              ),
            },
            {
              key: API_COPILOT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={API_COPILOT}>API Copilot</Link>
                </span>
              ),
              disabled: !userInfo?.webosapi,
            },
            {
              key: AUDIT_COPILOT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={AUDIT_COPILOT}>Audit Copilot</Link>
                </span>
              ),
              disabled: !userInfo?.audit,
            },
          ],
        },
        {
          label: (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI Management
            </span>
          ),
          children: [
            {
              key: DOCUMENT_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={DOCUMENT_MANAGEMENT}>Document Management</Link>
                </span>
              ),
            },
            {
              key: HISTORY_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={HISTORY_MANAGEMENT}>History Management</Link>
                </span>
              ),
            },
          ],
        },
        {
          label: securityLogActive && (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI Monitoring
            </span>
          ),
          children: [
            {
              key: SECURITY_MANAGEMENT,
              label: securityLogActive && (
                <span style={{ fontWeight: 500 }}>
                  <Link to={SECURITY_MANAGEMENT}>
                    AI Visualizer/Analyzer
                  </Link>
                </span>
              ),
            },
          ],
          disable: !userInfo?.securityLog || userInfo.securityLog === undefined,
        },
        {
          label: "",
        },
      ]);
    }
    if (ADMIN_ROLE.includes(userInfo?.role ?? "")) {
      setMenu([
        {
          label: (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI-powered Chat
            </span>
          ),
          children: [
            {
              key: SECURITY_COPILOT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={SECURITY_COPILOT}>Security Copilot</Link>
                </span>
              ),
            },
            {
              key: API_COPILOT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={API_COPILOT}>API Copilot</Link>
                </span>
              ),
              disabled: !userInfo?.webosapi,
            },
            {
              key: AUDIT_COPILOT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={AUDIT_COPILOT}>Audit Copilot</Link>
                </span>
              ),
              disabled: !userInfo?.audit,
            },
          ],
        },
        {
          label: (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI Management
            </span>
          ),
          children: [
            {
              key: DOCUMENT_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={DOCUMENT_MANAGEMENT}>Document Management</Link>
                </span>
              ),
            },
            {
              key: USER_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={USER_MANAGEMENT}>User Management</Link>
                </span>
              ),
            },
            {
              key: HISTORY_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={HISTORY_MANAGEMENT}>History Management</Link>
                </span>
              ),
            },
          ],
        },
        {
          label: securityLogActive && (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI Monitoring
            </span>
          ),
          children: [
            {
              key: SECURITY_MANAGEMENT,
              label: securityLogActive && (
                <span style={{ fontWeight: 500 }}>
                  <Link to={SECURITY_MANAGEMENT}>
                    AI Visualizer/Analyzer
                  </Link>
                </span>
              ),
            },
          ],
          disable: !userInfo?.securityLog || userInfo.securityLog === undefined,
        },
        {
          label: "",
        },
      ]);
    }
    if ([SUPER_ADMIN_ROLE].includes(userInfo?.role ?? "")) {
      setMenu([
        {
          label: (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI-powered Chat
            </span>
          ),
          children: [
            {
              key: SECURITY_COPILOT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={SECURITY_COPILOT}>Security Copilot</Link>
                </span>
              ),
            },
            {
              key: API_COPILOT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={API_COPILOT}>API Copilot</Link>
                </span>
              ),
              disabled: !userInfo?.webosapi,
            },
            {
              key: AUDIT_COPILOT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={AUDIT_COPILOT}>Audit Copilot</Link>
                </span>
              ),
              disabled: !userInfo?.audit,
            },
          ],
        },
        {
          label: (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI Management
            </span>
          ),
          children: [
            {
              key: DOCUMENT_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={DOCUMENT_MANAGEMENT}>Document Management</Link>
                </span>
              ),
            },
            {
              key: USER_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={USER_MANAGEMENT}>User Management</Link>
                </span>
              ),
            },
            {
              key: HISTORY_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={HISTORY_MANAGEMENT}>History Management</Link>
                </span>
              ),
            },
          ],
        },
        {
          label: (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI Configuration
            </span>
          ),
          children: [
            {
              key: CONFIG_PROMPT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={CONFIG_PROMPT}>Config Prompt</Link>
                </span>
              ),
            },
            {
              key: CONFIG_RULES,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={CONFIG_RULES}>Config Rules</Link>
                </span>
              ),
            },
            {
              key: CRAWLING_URL_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={CRAWLING_URL_MANAGEMENT}>URL Crawling</Link>
                </span>
              ),
            },
          ],
        },
        {
          label: (
            <span
              style={{
                fontWeight: 500,
                fontSize: "1.125rem",
              }}
            >
              AI Monitoring
            </span>
          ),
          children: [
            {
              key: SECURITY_MANAGEMENT,
              label: (
                <span style={{ fontWeight: 500 }}>
                  <Link to={SECURITY_MANAGEMENT}>
                    AI Visualizer/Analyzer
                  </Link>
                </span>
              ),
            },
          ],
        },
        {
          laebel: "...",
        },
      ]);
    }
  }, [userInfo?.role]);

  return (
    <div style={{ width: "100%" }}>
      <Menu
        selectedKeys={[key]}
        mode="horizontal"
        theme="light"
        className={styles.custom_menu}
        style={{
          whiteSpace: "nowrap",
          minWidth: userInfo?.role === SUPER_ADMIN_ROLE ? "570px" : "390px",
        }}
        items={menu}
      />
    </div>
  );
};

export default MenuComponent;
